import React, { useState } from "react";
import Logo from "../../assets/tiny_logo.svg";
import tinyLogo from "../../assets/logo.svg";
import { NavLink, Link, useLocation } from "react-router-dom";
import useDocumentScrollThrottled from "./HeaderUtility";
import Facebook from "../Icons/facebook";
import Instagram from "../Icons/Instagram";
import Linkedin from "../Icons/Linkedin";
import { motion, AnimatePresence } from "framer-motion";
import { CONSTANTS } from "../../helpers/Constant";
import Close from "../Icons/Close";
import {
  useAppInsightsContext,
  useTrackMetric,
} from "@microsoft/applicationinsights-react-js";

const Header = () => {
  let location = useLocation();
  const [showModalLayout, setShowModalLayout] = useState(false);
  const [shouldShowShadow, setShouldShowShadow] = useState(false);
  useDocumentScrollThrottled((callbackData) => {
    const { currentScrollTop } = callbackData;

    setShouldShowShadow(currentScrollTop > 2);
  });

  const shadowStyle = shouldShowShadow ? "tiny-header" : "";

  const openMenuMobile = () => {
    setShowModalLayout(true);
  };

  const appInsights = useAppInsightsContext();
  const trackNavigation = useTrackMetric(appInsights, "Navigation Tracker");

  return (
    <>
      {location.pathname === "/" ? (
        <header className={`sticky-wrapper ${shadowStyle}`}>
          <div className="container xs:container sm:container md:container lg:container w-full mx-auto">
            <div className="flex flex-row items-center justify-between">
              <Link to="/">
                <img
                  src={Logo}
                  alt=""
                  className="header-logo"
                  aria-label={CONSTANTS.COMPANY_NAME}
                />
                <img
                  src={tinyLogo}
                  alt=""
                  className="tiny-header-logo"
                  aria-label={CONSTANTS.COMPANY_NAME}
                />
              </Link>
              <button
                className="cursor-pointer mobile-menu px-0 py-2 md:hidden block"
                onClick={openMenuMobile}
                aria-label="Mobile Menu"
              >
                <span className="my-1"></span>
                <span className="my-1"></span>
                <span className="my-1"></span>
              </button>
              <div className="flex flex-row items-center md:flex hidden">
                <ul className="flex flex-row header-menu">
                  <li>
                    <NavLink to="/" exact onClick={trackNavigation}>
                      Home
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/about" onClick={trackNavigation}>
                      About
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/career" onClick={trackNavigation}>
                      Careers
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/contact" onClick={trackNavigation}>
                      Contact
                    </NavLink>
                  </li>
                </ul>
                <a
                  href="https://www.facebook.com/2MNordic"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on Facebook"
                >
                  <Facebook className="text-Gray-500 cursor-pointer mx-3 hover:text-pink-900 " />
                </a>
                <a
                  href="https://www.instagram.com/2mnordic/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on Instagram"
                >
                  <Instagram className="text-Gray-500 cursor-pointer mx-3 hover:text-pink-900" />
                </a>
                <a
                  href="https://www.linkedin.com/company/2mnordic-it-consulting-ab/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on Linkedin"
                >
                  <Linkedin
                    className="text-Gray-500 cursor-pointer mx-3 hover:text-pink-900"
                    width="20"
                    height="20"
                  />
                </a>
              </div>
            </div>
          </div>
        </header>
      ) : (
        <header className={`sticky-wrapper tiny-header`}>
          <div className="container xs:container sm:container md:container lg:container w-full mx-auto">
            <div className="flex flex-row items-center justify-between">
              <Link to="/" aria-label="Header Logo">
                <img
                  src={Logo}
                  alt=""
                  className="header-logo"
                  aria-label={CONSTANTS.COMPANY_NAME}
                />
                <img
                  src={tinyLogo}
                  alt=""
                  className="tiny-header-logo"
                  aria-label={CONSTANTS.COMPANY_NAME}
                />
              </Link>

              <button
                className="cursor-pointer mobile-menu px-0 py-2 md:hidden block"
                onClick={openMenuMobile}
              >
                <span className="my-1"></span>
                <span className="my-1"></span>
                <span className="my-1"></span>
              </button>

              <div className="flex flex-row items-center md:flex hidden">
                <ul className="flex flex-row header-menu">
                  <li>
                    <NavLink to="/" exact>
                      Home
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/about">About</NavLink>
                  </li>
                  <li>
                    <NavLink to="/career">Careers</NavLink>
                  </li>
                  <li>
                    <NavLink to="/contact">Contact</NavLink>
                  </li>
                </ul>
                <a
                  href="https://www.facebook.com/2MNordic"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on Facebook"
                >
                  <Facebook className="text-Gray-500 cursor-pointer mx-3 hover:text-pink-900 " />
                </a>
                <a
                  href="https://www.instagram.com/2mnordic/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on Instagram"
                >
                  <Instagram className="text-Gray-500 cursor-pointer mx-3 hover:text-pink-900" />
                </a>
                <a
                  href="https://www.linkedin.com/company/2mnordic-it-consulting-ab/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on Linkedin"
                >
                  <Linkedin
                    className="text-Gray-500 cursor-pointer mx-3 hover:text-pink-900"
                    width="20"
                    height="20"
                  />
                </a>
              </div>
            </div>
          </div>
        </header>
      )}

      {showModalLayout && (
        <AnimatePresence exitBeforeEnter>
          <motion.div
            className="backdrop"
            variants={CONSTANTS.MODAL_BACK_DROP}
            initial="hidden"
            animate="visible"
          >
            <motion.div
              className="w-full h-full"
              variants={CONSTANTS.MODAL_ANIMATE}
              initial="hidden"
              animate="visible"
              exit="hidden"
            >
              <div className=" max-w-full relative h-full">
                <div className="mid-container h-full">
                  <div className="container sm:container md:container lg:container w-full h-full mx-auto">
                    <div className="py-10">
                      <div className="flex flex-row justify-between">
                        <img src={tinyLogo} alt="" title="" />
                        <Close
                          className="cursor-pointer"
                          onClick={() => setShowModalLayout(false)}
                        />
                      </div>
                    </div>
                    <div className="flex flex-col ">
                      <ul className="flex flex-col header-menu">
                        <li className="my-1">
                          <NavLink to="/" exact>
                            Home
                          </NavLink>
                        </li>
                        <li className="my-2">
                          <NavLink to="/about">About</NavLink>
                        </li>
                        <li className="my-2">
                          <NavLink to="/career">Careers</NavLink>
                        </li>
                        <li className="my-2">
                          <NavLink to="/contact">Contact</NavLink>
                        </li>
                      </ul>
                    </div>
                    <footer className="bg-blue-500 py-6 absolute bottom-0 left-0 w-full">
                      <div className=" text-left">
                        <div className="flex flex-col md:flex-row justify-between">
                          <div className="flex flex-col md:flex-row ">
                            <span className="md:text-sm text-xs text-white opacity-70 px-3 py-3 md:py-0 font-avenirNextRegular">
                              Copyright &copy; 2021. {CONSTANTS.COMPANY_NAME} IT
                              Consulting AB - 556593-8973
                            </span>
                          </div>
                          <div className="flex flex-col md:flex-row  md:py-0 py-3">
                            <ul className="flex flex-row md:text-sm text-xs text-white opacity-70 px-3 font-avenirNextRegular">
                              <li className="px-2">GDPR - Privacy Notice</li>
                            </ul>
                            <div className="flex flex-row md:pt-0 pt-3 px-1">
                              <a
                                href="https://www.facebook.com/2MNordic"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Follow us on Facebook"
                              >
                                <Facebook
                                  width="28"
                                  height="28"
                                  className="text-white opacity-70 mx-2 cursor-pointer"
                                />
                              </a>
                              <a
                                href="https://www.instagram.com/2mnordic/"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Follow us on Instagram"
                              >
                                <Instagram
                                  width="28"
                                  height="28"
                                  className="text-white opacity-70 mx-2 cursor-pointer"
                                />
                              </a>
                              <a
                                href="https://www.linkedin.com/company/2mnordic-it-consulting-ab/"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Follow us on Linkedin"
                              >
                                <Linkedin
                                  width="28"
                                  height="28"
                                  className="text-white opacity-70 mx-2 cursor-pointer"
                                />
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </footer>
                  </div>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </AnimatePresence>
      )}
    </>
  );
};

export default Header;
